export default {
    "type": "object",
    "required": [ 'otcode', 'otcost', 'otdesc' ],
    "properties": {
        "otcode": {
            "type": "string",
            "default": "",
            "title": "Type Code",
            "x-cols": "6",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 2
            },
        },
        "otcost": {
            "type": "string",
            "default": "",
            "title": "Cost",
            "x-cols": "6",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 5,
                "prefix": "RM"
            },
        },
        "otdesc": {
            "type": "string",
            "default": "",
            "title": "Type Description",
            "x-cols": "12",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 255
            },
        },
    }
}
